import { useEffect, useState } from "react";
import { IoClose } from "react-icons/io5";

const AddWardModal = ({ open, onClose, onSave, editData }) => {
  const [form, setForm] = useState({
    wardName: "",
    wardDescription: "",
  });

  useEffect(() => {
    if (open) {
      setForm({
        wardName: editData?.wardName || "",
        wardDescription: editData?.wardDescription || "",
      });
    } else {
      setForm({ wardName: "", wardDescription: "" });
    }
  }, [open, editData]);

  if (!open) return null;

  return (
    <div className="admin-modal-overlay">
      <div className="admin-modal">
        <div className="admin-modal-header">
          <div className="admin-modal-title">
            {editData ? "Edit Ward" : "Add Ward"}
          </div>
          <button className="admin-modal-close" onClick={onClose}>
            <IoClose />
          </button>
        </div>

        <div className="admin-form-body">
          <label className="admin-label">Ward Name <span>*</span></label>
          <input
            className="admin-input"
            value={form.wardName}
            onChange={(e) => setForm({ ...form, wardName: e.target.value })}
            name="wardName"
            placeholder="Enter Ward Name"
            required
          />
        </div>

        <div className="admin-form-body">
          <label className="admin-label">Ward Description</label>
          <textarea
            className="admin-input"
            value={form.wardDescription}
            onChange={(e) => setForm({ ...form, wardDescription: e.target.value })}
            name="wardDescription"
            placeholder="Enter Ward Description"
            rows="3"
          />
        </div>


        <div className="admin-form-footer">
          <button className="admin-btn-cancel" onClick={onClose}>
            CANCEL
          </button>
          <button className="admin-btn-save" disabled={!form.wardName.trim() || !form.wardDescription.trim()}
            onClick={() => onSave( form )}>
            SAVE
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddWardModal;
